import * as React from "react";
import { decorateEditorialHtml } from "../../../ContentUtilities";
import { UitkText } from "uitk-react-text";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { EditorialModel } from "src/typings/microserviceModels/content-flex-module";

const CONTENT_ID_COUNT = 4;
export const CardComparisonNoFeeBenefitsEditorial = (props: { items: EditorialModel[] }) => {
  const { items } = props;

  if (items.length !== CONTENT_ID_COUNT) {
    return null;
  }

  const [noFeeBenefits3xIcon, noFeeBenefits3xContent, noFeeBenefits1xIcon, noFeeBenefits1xContent] = React.useMemo(
    () => items.map((item) => decorateEditorialHtml(item.text)),
    []
  );

  return (
    <div className="uitk-type-center xl-l-padding-twelve l-l-padding-twelve m-x-padding-twelve xl-l-margin-six l-l-margin-six m-x-margin-twelve">
      <UitkLayoutGrid>
        <UitkLayoutGridItem>
          <UitkLayoutFlex space="three" alignItems="center">
            <UitkLayoutFlexItem>
              <div dangerouslySetInnerHTML={noFeeBenefits3xIcon} />
            </UitkLayoutFlexItem>
            <UitkLayoutFlexItem>
              <div>
                <UitkText size={400} weight="bold" align="left">
                  <div dangerouslySetInnerHTML={noFeeBenefits3xContent} />
                </UitkText>
              </div>
            </UitkLayoutFlexItem>
          </UitkLayoutFlex>
        </UitkLayoutGridItem>
        <UitkLayoutGridItem className="all-t-padding-two">
          <UitkLayoutFlex space="three" alignItems="center">
            <UitkLayoutFlexItem>
              <div dangerouslySetInnerHTML={noFeeBenefits1xIcon} />
            </UitkLayoutFlexItem>
            <UitkLayoutFlexItem>
              <div>
                <UitkText size={400} weight="bold" align="left">
                  <div dangerouslySetInnerHTML={noFeeBenefits1xContent} />
                </UitkText>
              </div>
            </UitkLayoutFlexItem>
          </UitkLayoutFlex>
        </UitkLayoutGridItem>
      </UitkLayoutGrid>
    </div>
  );
};

export default CardComparisonNoFeeBenefitsEditorial;
